// extracted by mini-css-extract-plugin
export default {"title":"plate-number-form_title__IC4pE","desc":"plate-number-form_desc__qtbGN","section":"plate-number-form_section__als13"};